import { createReducer, on, Action } from '@ngrx/store';
import { ApiError, BasketCheckoutOperationResponse } from '../../client/src';
import { LoadState } from '@nx-ng/types';
import { CompleteCheckoutActions } from '../../actions';

export interface ICompleteCheckoutState {
  checkoutResponse?: BasketCheckoutOperationResponse;
  loaded: LoadState;
  error?: ApiError | string;
}

export const initialState: ICompleteCheckoutState = {
  loaded: LoadState.NOT_LOADED,
};

const completeCheckoutReducer = createReducer(
  initialState,
  on(CompleteCheckoutActions.checkoutAPI_checkoutBasket, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    error: undefined,
  })),
  on(
    CompleteCheckoutActions.checkoutAPI_checkoutBasketSuccess,
    (state, { response }: { response: BasketCheckoutOperationResponse }) => ({
      ...state,
      checkoutResponse: response,
      loaded: LoadState.LOADED,
    })
  ),
  on(
    CompleteCheckoutActions.checkoutAPI_checkoutBasketFailure,
    (state, { error }) => ({
      ...state,
      error,
      loaded: LoadState.FAILED,
    })
  )
);

export function reducer(
  state: ICompleteCheckoutState | undefined,
  action: Action
) {
  return completeCheckoutReducer(state, action);
}
